<h3>
    Netzzuordnungen Status
    <mat-icon
      svgIcon="innogy_picto_speech-bubble_exclamationmark"
      aria-hidden="false"
      [attr.aria-label]="tooltipText"
      [matTooltip]="tooltipText"
      matTooltipPosition="above"
      matTooltipClass="multiline-tooltip"
    >
    </mat-icon>
</h3>
<mat-card>
    <mat-card-content>
        @if (netzzuordungImport()?.importAccepted === true) {
            <redispatch-netzverknuepfungen-list [netzzuordungImport]="netzzuordungImport()"></redispatch-netzverknuepfungen-list>
        } @else if (netzzuordungImport()?.importAccepted === false) {
            <redispatch-netzzuordnung-import-report [netzzuordungImport]="netzzuordungImport()"></redispatch-netzzuordnung-import-report>
        }
    </mat-card-content>
    <mat-card-footer>
        @if (netzzuordungImport() === null) {
            <div class="status-message no-top-margin" data-qa="no-import-available">Es liegt kein Netzzuordnungsimport im System vor.</div>
        } @else if (netzzuordungImport()?.importAccepted === true) {
            <div class="feedback-primary status-message">Keine Grenzwertüberschreitung</div>
        } @else if (netzzuordungImport()?.importAccepted === false) {
            <div class="feedback-warn status-message"><strong>{{netzzuordungImport().importDate | date }}&#32;Import geblockt</strong></div>
        }
    </mat-card-footer>
</mat-card>
